// import { Typography } from '@mui/material';
import Typography from '@/components/shared/typography/typography.component';
import { ReactNode } from 'react';
import colors from '@/theme/colors.module.scss';
import { IVariant } from '@/components/shared/typography/typography.types';

interface ComponentProps {
    children?: ReactNode;
}
interface CustomTypographyProps extends ComponentProps {
    variant?: IVariant;
}
const CarProfileInfoContainer = ({ children }: ComponentProps) => {
    return (
        <div className='p-0 border-0 gap-2 flex flex-col relative md:py-6 md:px-4 md:border  md:border-gray-200  md:rounded-2xl md:gap-4'>
            <>{children}</>
        </div>
    );
};

const CarProfileCarName = ({ children, variant }: CustomTypographyProps) => {
    return (
        <Typography className='text-secondary opacity-100' variant={variant}>
            <>{children}</>
        </Typography>
    );
};
const CarProfileTrim = ({ children, variant }: CustomTypographyProps) => {
    return (
        <Typography
            className='text-secondary opacity-100'
            variant={variant}
            color={colors.gray500}
        >
            <>{children}</>
        </Typography>
    );
};

const CarProFileMoreInfoContainer = ({ children }: ComponentProps) => {
    return (
        <div className='flex justify-between py-0 w-full border-b-0  border-gray-200 md:border-b md:justify-start md:py-4 md:gap-4'>
            <>{children}</>
        </div>
    );
};
const CarProFileMoreInfoItemContainer = ({ children }: ComponentProps) => {
    return (
        <div className='flex items-center gap-1'>
            <>{children}</>
        </div>
    );
};

const CarProfileMoreInfoText = ({
    children,
    variant,
}: CustomTypographyProps) => {
    return (
        <Typography className='text-[#475466]  -mb-1.5  opacity-100 text-sm font-normal leading-tight' variant={variant}>
            <>{children}</>
        </Typography>
    );
};
const CarProfileCarPrice = ({ children, variant }: CustomTypographyProps) => {
    return (
        <Typography className='text-primary opacity-100' variant={variant}>
            <>{children}</>
        </Typography>
    );
};

const CarProfileCurrency = ({ children, variant }: CustomTypographyProps) => {
    return (
        <Typography className='teext-gray-500 mr-1 opacity-100' variant={variant}>
            <>{children}</>
        </Typography>
    );
};

const CarProfileSubtitle = ({ children, variant }: CustomTypographyProps) => {
    return (
        <Typography className='text-gray-500 font-medium text-sm leading-5 mb-1 mr-1 opacity-100' variant={variant}>
            <>{children}</>
        </Typography>
    );
};

const CarProfileInstallmentPrice = ({
    children,
    variant,
}: CustomTypographyProps) => {
    return (
        <Typography
            className='text-secondary opacity-100'
            variant={variant}
        >
            <>{children}</>
        </Typography>
    );
};

export {
    CarProfileInfoContainer,
    CarProfileCarName,
    CarProfileTrim,
    CarProFileMoreInfoContainer,
    CarProFileMoreInfoItemContainer,
    CarProfileMoreInfoText,
    CarProfileCarPrice,
    CarProfileCurrency,
    CarProfileSubtitle,
    CarProfileInstallmentPrice,
};
